module.exports = __webpack_public_path__ + "media/assets/images/banner-information_old-2be47643bcca1e33f9209f8de3de248c.jpg";